/* Apex Love Spell — Wedding Palette Studio. One block equals one complete look. */
(() => {
  class PaletteStudio extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialised) return;
      this.dataset.initialised = "true";
      this.combinations = this.readJson("[data-palette-combinations]") || {};
      this.selectElement = this.querySelector("[data-palette-combination]");
      const image = this.querySelector("[data-palette-image-primary]");
      this.fallbackImage = image?.src || "";
      this.fallbackAlt = image?.alt || "";
      if (!this.selectElement || !Object.keys(this.combinations).length) return;
      this.selectElement.addEventListener("change", () => this.select(this.selectElement.value));
      this.addEventListener("click", (event) => this.onClick(event));
      this.select(this.selectElement.value || Object.keys(this.combinations)[0]);
      this.track("palette_studio_viewed");
    }

    readJson(selector) {
      try { return JSON.parse(this.querySelector(selector)?.textContent || "null"); }
      catch { return null; }
    }

    label(item) { return `Bride: ${item.bride} · Bridesmaids: ${item.bridesmaid}`; }

    select(id) {
      const item = this.combinations[id] || this.combinations[Object.keys(this.combinations)[0]];
      if (!item) return;
      this.state = { id, ...item };
      this.selectElement.value = id;
      this.render();
      this.track("palette_combination_selected", { bride_color: item.bride, bridesmaid_color: item.bridesmaid });
    }

    closeMenu() {
      const menu = this.querySelector('[data-palette-menu="combination"]');
      const trigger = this.querySelector('[data-palette-trigger="combination"]');
      if (menu) menu.hidden = true;
      this.querySelectorAll("[data-palette-close]").forEach((backdrop) => (backdrop.hidden = true));
      trigger?.closest(".lsp__palette-select")?.classList.remove("is-open");
      trigger?.setAttribute("aria-expanded", "false");
    }

    onClick(event) {
      const trigger = event.target.closest('[data-palette-trigger="combination"]');
      if (trigger) {
        const menu = this.querySelector('[data-palette-menu="combination"]');
        const shouldOpen = menu?.hidden;
        this.closeMenu();
        if (menu && shouldOpen) {
          menu.hidden = false;
          this.querySelectorAll("[data-palette-close]").forEach((backdrop) => (backdrop.hidden = false));
          trigger.closest(".lsp__palette-select")?.classList.add("is-open");
          trigger.setAttribute("aria-expanded", "true");
        }
        return;
      }
      const choice = event.target.closest("[data-palette-choice]");
      if (choice) {
        this.closeMenu();
        this.select(choice.dataset.paletteChoice);
        this.querySelector('[data-palette-trigger="combination"]')?.focus();
        return;
      }
      if (event.target.closest("[data-palette-close]")) this.closeMenu();
    }

    render() {
      const item = this.state;
      const image = this.querySelector("[data-palette-image-primary]");
      if (image) {
        image.src = item.image || this.fallbackImage;
        image.alt = item.alt || this.fallbackAlt || this.label(item);
      }
      const value = this.querySelector("[data-palette-combination-value]");
      if (value) value.textContent = this.label(item);
      const brideSwatch = this.querySelector("[data-palette-bride-swatch]");
      if (brideSwatch) brideSwatch.style.backgroundColor = item.brideSwatch || "";
      const bridesmaidSwatch = this.querySelector("[data-palette-bridesmaid-swatch]");
      if (bridesmaidSwatch) bridesmaidSwatch.style.backgroundColor = item.bridesmaidSwatch || "";
      this.querySelectorAll("[data-palette-choice]").forEach((button) =>
        button.setAttribute("aria-selected", String(button.dataset.paletteChoice === item.id)),
      );
    }

    track(name, payload = {}) {
      const detail = { event: `love_spell_${name}`, ...payload };
      window.dataLayer?.push(detail);
      window.dispatchEvent(new CustomEvent("love-spell:analytics", { detail }));
    }
  }
  customElements.get("lsp-palette-studio") || customElements.define("lsp-palette-studio", PaletteStudio);
})();
